import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CarouselTravelComponent } from './carousel-travel.component';
import { PoiSelectCarouselModule } from '../../components/poi-select-carousel';

const MODULES = [
  CommonModule
];

const LIBRARIES = [
  PoiSelectCarouselModule
];

const COMPONENTS = [
  CarouselTravelComponent
];

@NgModule({
  imports: [
    MODULES,
    LIBRARIES
  ],
  declarations: [
    COMPONENTS
  ],
  exports: [
    CarouselTravelComponent
  ]
})
export class CarouselTravelModule { }
